<template>
  <iframe
    src="//www.facebook.com/plugins/likebox.php?locale=et_EE&amp;href=https%3A%2F%2Fwww.facebook.com%2Fpages%2FCosta-Sol-Rent%2F365525643554820&amp;width=235&amp;height=65&amp;show_faces=false&amp;colorscheme=light&amp;stream=false&amp;show_border=true&amp;header=false" scrolling="no"
    frameborder="1"
    style="border: 1px solid silver; overflow:hidden; width:235px; height:68px;margin-top:10px;"
    allowtransparency="true"
    ></iframe>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'FacebookFrame'
}
</script>

<style>

</style>
